var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.isLoading,"rounded":"sm"}}),_c('DocumentTable',{attrs:{"isLoading":_vm.isLoading,"tableData":_vm.allUserFiles,"tableHeaders":_vm.tableTitles},on:{"rowClicked":_vm.rowClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }